import React from 'react';
import { IntlProvider, load } from '@progress/kendo-react-intl';
import weekData from 'cldr-core/supplemental/weekData.json';
import esCaGregorian from 'cldr-dates-full/main/es/ca-gregorian.json';
import frCaGregorian from 'cldr-dates-full/main/fr/ca-gregorian.json';
import esDateFields from 'cldr-dates-full/main/es/dateFields.json';
import frDateFields from 'cldr-dates-full/main/fr/dateFields.json';
import esNumbers from 'cldr-numbers-full/main/es/numbers.json';
import frNumbers from 'cldr-numbers-full/main/fr/numbers.json';
import { getCurrentLanguage } from '@utils/i18n';
// Load CLDR data for date/time and number formatting once when module is imported
load(weekData, esCaGregorian, frCaGregorian, esDateFields, frDateFields, esNumbers, frNumbers);
/**
 * KendoIntlProvider wraps components with IntlProvider
 * to provide Kendo React UI components with date/time and number formatting based on locale.
 *
 * @example
 * <KendoIntlProvider>
 *   <MyComponent />
 * </KendoIntlProvider>
 */
export function KendoIntlProvider({ children, locale = getCurrentLanguage() }) {
    return React.createElement(IntlProvider, { locale: locale }, children);
}
